export const STORAGE_TTL = 2 * 60 * 1000; // 20 minutes in milliseconds

export const APP_NAME = 'Sales agent'